/* eslint-disable react/style-prop-object */
import React from "react";
import Close from "../../../../Helpers/CloseBtn/Close";

export default function ObjectDraggableHead({ data, close, toggleMinimize }) {
	const truncateItem = (text) => {
		const maxLength = 25;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	return (
		<div className="object-draggable-head">
			<div className="object-draggable-main">
				<div title={data?.name}>{truncateItem(data?.name)}</div>
				<div className="flex-between">
					<img
						src={`${process.env.PUBLIC_URL}/assets/Minimize.svg`}
						alt="minimize"
						className="close mx-2"
						onClick={toggleMinimize}
					/>
					<Close close={close} img="Close" style="close close-24" />
				</div>
			</div>
		</div>
	);
}
